import { getDataRequest } from "@/store/modules/maintance/constants";
export default
function getUrl(flag, type) {
	const flagItem = getDataRequest.find(item => item.KEY === flag);

	return flagItem[type];
}

